import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'

import { StatusButtonFactory } from '../StatusButtonFactory'
import type { FactoryArg } from '../StatusButtonFactory/StatusButtonFactory'

const {
  colors: { primary, gray },
} = styles

const dotStyle = css`
  display: inline-block;
  margin-right: 4px;
  content: '';
  width: 4px;
  height: 4px;
  border-radius: var(--Radius-Circle);
`

const status: FactoryArg<'출석' | '등원' | '하원'> = {
  출석: {
    text: '출석',
    css: {
      button: css`
        border: 1px solid ${gray.$400};
        :hover {
          border: 1px solid ${gray.$500};
        }
      `,
      text: css`
        color: ${gray.$700};
        ${typo.caption01};
      `,
    },
  },
  등원: {
    text: '등원',
    css: {
      button: css`
        border: 1px solid ${primary};
      `,
      text: css`
        color: ${primary};
        ${typo.caption01};

        ::before {
          ${dotStyle};
          background-color: ${primary};
        }
      `,
    },
  },
  하원: {
    text: '하원',
    css: {
      button: css`
        border: 1px solid ${gray.$900};
      `,
      text: css`
        color: ${gray.$900};
        ${typo.caption01};

        ::before {
          ${dotStyle};
          background-color: ${gray.$900};
        }
      `,
    },
  },
} as const

export const StatusButton = StatusButtonFactory(status)
